import React from 'react';
import { Box, Card, Grid2 as Grid, Skeleton } from "@mui/material";

export const HomeSkeleton = () => {
    return (
        <Box sx={{ width: "100%", pb: 4, pt: 1, direction: "rtl" }}>

            {/* 2. Category Quick Buttons Skeleton */}
            <Box sx={{ px: 2, mb: 3 }}>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    {[1, 2, 3, 4].map((item) => (
                        <Grid key={"cat-skel-" + item} size={{ xs: 3, sm: 3, md: 3 }} sx={{ textAlign: "center" }}>
                            <Skeleton
                                variant="rounded"
                                animation="wave"
                                sx={{
                                    width: { xs: 64, sm: 72 },
                                    height: { xs: 64, sm: 72 },
                                    borderRadius: 3,
                                    mx: "auto",
                                    mb: 1
                                }}
                            />
                            <Skeleton
                                variant="text"
                                animation="wave"
                                width="60%"
                                height={18}
                                sx={{ mx: "auto" }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {/* 1. Main Hero Banner Skeleton */}
            <Box sx={{ px: 2, mb: 3 }}>
                <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{
                        width: "100%",
                        height: { xs: 180, sm: 220, md: 260 },
                        borderRadius: 4,
                        aspectRatio: "16 / 9"
                    }}
                />
            </Box>
            {/* 3. Section Title Skeleton */}
            <Box sx={{ px: 2.5, mb: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Skeleton variant="text" animation="wave" width="35%" height={32} />
                <Skeleton variant="text" animation="wave" width="15%" height={24} />
            </Box>

            {/* 4. Horizontal Card Carousel Skeleton */}
            <Box sx={{ px: 2, mb: 3, display: "flex", gap: 2, overflow: "hidden" }}>
                {[1, 2, 3].map((card) => (
                    <Card
                        key={"card-skel-" + card}
                        elevation={4}
                        sx={{
                            minWidth: { xs: "75%", sm: "45%", md: "30%" },
                            flexShrink: 0,
                            borderRadius: 3,
                            overflow: "hidden"
                        }}
                    >
                        <Skeleton
                            variant="rectangular"
                            animation="wave"
                            height={150}
                            sx={{ width: "100%" }}
                        />
                        <Box sx={{ p: 1.5 }}>
                            <Skeleton variant="text" animation="wave" width="70%" height={24} sx={{ mb: 0.5 }} />
                            <Skeleton variant="text" animation="wave" width="50%" height={18} sx={{ mb: 1 }} />
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Skeleton variant="rounded" animation="wave" width="30%" height={20} />
                                <Skeleton variant="rounded" animation="wave" width="35%" height={24} />
                            </Box>
                        </Box>
                    </Card>
                ))}
            </Box>

            {/* 5. Secondary Full Banner Skeleton */}
            <Box sx={{ px: 2, mb: 3 }}>
                <Skeleton
                    variant="rounded"
                    animation="wave"
                    sx={{
                        width: "100%",
                        height: { xs: 130, sm: 160 },
                        borderRadius: 4
                    }}
                />
            </Box>
        </Box>
    );
};

export default HomeSkeleton;
